import React from "react";
import { Link } from "react-router-dom";

const StudentsList = ({ students_to_render }) => {
  return (
    <section className="probootstrap-section">
      <div className="container alum">
        <div className="row">
          {/* strat map on students */}
          {students_to_render.map(({ id, name, speciality, img }) => {
            return (
              <div className="col-sm-6 col-md-4 col-lg-3" key={id}>
                <div className="thumbnail">
                  <div className="overlay">
                    <Link to={`/alumni/${id}`} target="_blank">
                      <i className="fa fa-eye"></i>
                      <span>View Profile</span>
                    </Link>
                  </div>
                  <img src={img !== "" ? img : "img/avatar.png"} alt="..." />
                  <div className="caption">
                    <h4>{name}</h4>
                    <p>{speciality ? speciality : "no-speciality"}</p>
                  </div>
                </div>
              </div>
            );
          })}
          {/* end map on students */}
        </div>
      </div>
    </section>
  );
};

export default StudentsList;
